import React, { Component } from 'react';
import PropTypes from "prop-types";

class ImageGalleryWrapper extends Component {
    renderImages = () => {
        return this.props.images.map((imageUrl, i) => {
            const altText = (this.props.altTexts && this.props.altTexts[i] && this.props.altTexts[i].trim())
                ? this.props.altTexts[i]
                : (this.props.name ? `'${this.props.name}' Image #${i + 1}` : `Image #${i + 1}`);
            return(
                <span className="image__block" key={i}>
                    <img src={imageUrl} id={i} alt={altText}/>
                </span>
            );
        });
    };

    render() {
        return(
            <div className="images_row">
                {this.renderImages()}
            </div>
        )
    }
}

ImageGalleryWrapper.propTypes = {
    images: PropTypes.array.isRequired,
    altTexts: PropTypes.array,
    name: PropTypes.string,
};

export default ImageGalleryWrapper;
